

















































































import { PropType } from 'vue';

// utilities
import mixins from '@/utils/mixins';

// mixins
import componentState from '@/mixins/state';

import { QuoteProductItem, Quote, IQuoteProductCategory } from '@/models/quote';
import { cloneDeep } from 'lodash';

export default mixins(componentState).extend({
  name: 'QuoteProductItemBody',

  props: {
    quote: Object as PropType<Quote>,

    quoteCategories: Array as PropType<IQuoteProductCategory[]>,

    items: Array as PropType<QuoteProductItem[]>,

    editable: Boolean,
    currencyCode: String
  },

  data() {
    return {
      expanded: this.quoteCategories.map(() => {
        return false;
      }) as boolean[],
      loading: false
    };
  },

  watch: {
    quote: {
      handler(value: Quote) {
        value.categories.forEach(() => {
          this.expanded.push(false);
        });
      },
      deep: true,
      immediate: true
    }
  },

  methods: {
    updateQuoteCategory(category: IQuoteProductCategory, itemIndex: number) {
      const categories = cloneDeep(this.quoteCategories);
      categories.splice(itemIndex, 1, category);
      this.$emit('update:quote-categories', categories);
    }
  }
});
